interface IconPinProps extends React.SVGProps<SVGSVGElement> {}

const IconUnpin = (props: IconPinProps) => {
  return (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.10217 3.74928L4.04491 2.82269L4.04605 1.60209L3.22229 1.60409L3.22381 0.0163065L10.7001 0L10.6983 1.58726L9.87451 1.58926L9.87116 5.17539C10.9851 5.86786 11.7613 6.94754 11.94 8.19239L10.1766 8.19662L6.01559 4.54982V1.44481H5.10217V3.74928ZM7.48106 9.23056L7.47764 13.2318C7.4772 13.6533 7.23943 13.9997 6.94884 14C6.65913 14.0006 6.42111 13.6564 6.42188 13.234L6.4267 8.3065L7.48106 9.23056ZM6.31132 8.20538L1.96901 8.21508C2.11321 7.22229 2.63658 6.33332 3.40687 5.65988L6.31132 8.20538ZM0.645885 0.975864L13 11.8032L12.3541 12.3692L0 1.54193L0.645885 0.975864Z"
        fill="#E6A300"
      />
    </svg>
  );
};

export { IconUnpin };
